<template>
  <div>
    <h2>Zarządzanie wdrożeniami</h2>
    <v-btn color="primary" @click="
      newCompanyVm.name = '';
    newCompanyDialog = true;
    ">Nowe wdrożenie</v-btn>
    <data-table :footer-props="{ itemsPerPageOptions: [15, 25, 50, 100, -1] }" :headers="headers" :items="companies"
      :loading="!isInit">
      <template v-slot:item.name="props">
        <v-edit-dialog :return-value.sync="props.item.name" large @save="saveEdit(props.item)">
          {{ props.item.name }}
          <template v-slot:input>
            <v-text-field v-model="props.item.name" autofocus counter label="Edycja" single-line></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.shortName="props">
        <v-edit-dialog :return-value.sync="props.item.shortName" large @save="saveEdit(props.item)">
          {{ props.item.shortName }}
          <template v-slot:input>
            <v-text-field v-model="props.item.shortName" autofocus counter label="Edycja" single-line></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.email="props">
        <v-edit-dialog :return-value.sync="props.item.email" large @save="saveEdit(props.item)">
          {{ props.item.email }}
          <template v-slot:input>
            <v-text-field v-model="props.item.email" autofocus counter label="Edycja" single-line></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.domain="props">
        <v-edit-dialog :return-value.sync="props.item.domain" large @save="saveEdit(props.item)">
          {{ props.item.domain }}
          <template v-slot:input>
            <v-text-field v-model="props.item.domain" autofocus counter label="Edycja" single-line></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.createDateTime="{ item }">{{
        item.createDateTime
          ? moment(item.createDateTime).format("YYYY-MM-DD HH:mm:ss")
          : "Brak danych"
      }}</template>
      <template v-slot:item.validFromDateTime="props">
        <v-edit-dialog :return-value.sync="props.item.validFromDateTime" large @save="saveEdit(props.item)">
          {{
            props.item.validFromDateTime
              ? moment(props.item.validFromDateTime).format("YYYY-MM-DD")
              : ""
          }}
          <template v-slot:input>
            <v-date-picker :value="props.item.validFromDateTime
              ? moment(props.item.validFromDateTime).format('YYYY-MM-DD')
              : null
              " @input="(arg) => (props.item.validFromDateTime = arg)"></v-date-picker>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.validToDateTime="props">
        <v-edit-dialog :return-value.sync="props.item.validToDateTime" large @save="saveEdit(props.item)">
          {{
            props.item.validToDateTime
              ? moment(props.item.validToDateTime).format("YYYY-MM-DD")
              : ""
          }}
          <template v-slot:input>
            <v-date-picker :value="props.item.validToDateTime
              ? moment(props.item.validToDateTime).format('YYYY-MM-DD')
              : null
              " @input="(arg) => (props.item.validToDateTime = arg)"></v-date-picker>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.accessToken="{ item }">
        <v-btn v-if="!item.showToken" color="primary" @click="item.showToken = true">Pokaż kod</v-btn>
        <span v-else>{{ item.accessToken }}</span>
      </template>
      <template v-slot:item.readonlyAccessToken="{ item }">
        <v-btn v-if="!item.showReadonlyToken" color="primary" @click="item.showReadonlyToken = true">Pokaż kod</v-btn>
        <span v-else>{{ item.readonlyAccessToken }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on">Opcje</v-btn>
          </template>
          <v-list>
            <v-list-item link @click="openNewGuidDialog(item)">
              <v-list-item-title>
                Wygeneruj nowy klucz dostępu
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="openNewReadonlyGuidDialog(item)">
              <v-list-item-title>
                Wygeneruj nowy klucz dostępu tylko do odczytu
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="routeToConfiguration(item)">
              <v-list-item-title> Konfiguracja </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="routeToFront(item)">
              <v-list-item-title>
                Przejdź na stronę internetową rezerwacji
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="$router.push('/Companies/Operations/' + item.id)">
              <v-list-item-title> Operacje </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="openCopyConfigsDialog(item)">
              <v-list-item-title>
                Kopiuj ustawienia z innego wdrozenia
              </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="$refs.ipwhitelist.open(item.id)">
              <v-list-item-title> Zaufane adresy IP </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="editEmailSender(item)">
              <v-list-item-title> Edycja wysyłki mailowej </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="editSecurity(item)">
              <v-list-item-title> Edycja zabezpieczeń </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="editExternalApi(item)">
              <v-list-item-title> API zewnetrzne </v-list-item-title>
            </v-list-item>
            <v-list-item link @click="getSmsApiPoints(item)">
              <v-list-item-title> Punkty SmsApi </v-list-item-title>
            </v-list-item>
            <v-list-item :input-value="true" color="error" link @click="openRemoveCompanyDialog(item)">
              <v-list-item-title> Usuń wdrożenie </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </data-table>
    <v-dialog v-model="newCompanyDialog" width="600">
      <v-card>
        <v-card-title>
          <h3>Nowe wdrożenie</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="newCompanyVm.name" label="Nazwa"></v-text-field>
          <v-text-field v-model="newCompanyVm.shortName" label="Skrócona nazwa"></v-text-field>
          <span class="red--text">{{ addCompanyMessage }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="newCompany">Dodaj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmRemoveDialog" persistent width="600">
      <v-card>
        <v-card-title>Czy na pewno chcesz usunąc to wdrożenie?</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>ID: {{ removeCompany.id }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Nazwa: {{ removeCompany.name }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn block color="primary" @click="confirmRemoveCompany">Tak</v-btn>
            </v-col>
            <v-col>
              <v-btn block color="secondary" @click="removeNotConfirm">Nie</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmNewGuidDialog" persistent width="600">
      <v-card>
        <v-card-title>Czy na pewno chcesz wygenerowac nowy klucz dostępu dla tego
          wdrożenia?</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>ID: {{ newGuidVm.id }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Nazwa: {{ newGuidVm.name }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn block color="primary" @click="generateNewGuid">Tak</v-btn>
            </v-col>
            <v-col>
              <v-btn block color="secondary" @click="newGuidNotConfirm">Nie</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmNewReadonlyGuidDialog" persistent width="600">
      <v-card>
        <v-card-title>Czy na pewno chcesz wygenerowac nowy klucz tylko do odczytu dla tego
          wdrożenia?</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col>ID: {{ newGuidVm.id }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>Nazwa: {{ newGuidVm.name }}</v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn block color="primary" @click="generateNewReadonlyGuid">Tak</v-btn>
            </v-col>
            <v-col>
              <v-btn block color="secondary" @click="newGuidNotConfirm">Nie</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="copyConfigsDialog" persistent width="600">
      <v-card>
        <v-card-title>Kopiuj ustawienia</v-card-title>
        <v-card-text>
          <v-select v-model="copyVm.fromCompany" :items="companies" item-text="name" item-value="id"
            label="Wybierz wdrożenie z którego chcesz skopiować ustawienia"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="copyConfigConfirm">Zapisz</v-btn>
          <v-btn color="secondary" @click="copyConfigsDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailSenderDialog" persistent width="600">
      <v-card v-if="emailSettings">
        <v-card-title>Edycja wysyłki mailowej</v-card-title>
        <v-card-text>
          <v-switch v-model="emailSettings.enable" label="Uruchomiony"></v-switch>
          <v-switch v-model="emailSettings.useSsl" label="Włączony SSL"></v-switch>
          <v-text-field v-model="emailSettings.host" label="Host"></v-text-field>
          <v-text-field v-model="emailSettings.port" type="number" label="Port"></v-text-field>
          <v-text-field v-model="emailSettings.userName" label="Nazwa użytkownika"></v-text-field>
          <v-text-field v-model="emailSettings.password" type="password" label="Hasło"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveEmailSender">Zapisz</v-btn>
          <v-btn color="secondary" @click="emailSenderDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card></v-dialog>
    <v-dialog v-model="securitySettingsDialog" persistent width="600">
      <v-card v-if="securitySettings">
        <v-card-title>Edycja dodatkowych zabezpieczeń</v-card-title>
        <v-card-text>
          <v-switch v-model="securitySettings.additionalCaptchaBeforeCalendar"
            label="Dodatkowa HCaptcha po wybraniu dnia w kalendarzu"></v-switch>
          <v-switch v-model="securitySettings.enableBlockIpOnIncorrectRequest"
            label="Blokowanie IP po niepoprawnych zapytaniach do API"></v-switch>

          <v-text-field v-model="securitySettings.blockHours" label="Liczba godzin blokady IP"></v-text-field>
          <v-switch v-model="securitySettings.confirmIpSameAsBlockIp"
            label="Wymagaj jednakowego IP na blokadzie oraz potwierdzeniu"></v-switch>

          <v-switch v-model="securitySettings.blockVpn" label="Blokowanie sieci VPN"></v-switch>

          <v-text-field v-model="securitySettings.vpnApiKey" type="password" label="Klucz do vpnapi.io"></v-text-field>
          <v-text-field v-model="securitySettings.blockVpnFrom" type="time"
            label="Działanie blokady VPN od godziny"></v-text-field>
          <v-text-field v-model="securitySettings.blockVpnTo" type="time"
            label="Działanie blokady VPN do godziny"></v-text-field>
          <v-text-field v-model="securitySettings.allowedCountryCode"
            label="Dozwolone kody krajów oddzielone przecinkiem"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveSecurity">Zapisz</v-btn>
          <v-btn color="secondary" @click="securitySettingsDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card></v-dialog>
    <v-dialog v-model="smsApiPointsDialog" persistent width="600">
      <v-card v-if="smsApiPointsVm">
        <v-card-title>{{ smsApiPointsVm.companyName }} </v-card-title><v-card-text>
          <div v-if="smsApiPointsVm.status == 0">
            Punkty: {{ smsApiPointsVm.points }}
          </div>
          <div v-if="smsApiPointsVm.status == 1">
            Brak tokenu SmsApi w konfiguracji wdrożenia
          </div>
          <div v-if="smsApiPointsVm.status == 2">
            Błąd połączenia do SmsApi
            <br />
            ERROR:
            {{ smsApiPointsVm.error }}
          </div>
        </v-card-text>
        <v-card-actions><v-btn color="primary"
            @click="smsApiPointsDialog = false">Zamknij</v-btn></v-card-actions></v-card>
    </v-dialog>
    <v-dialog v-model="externalApiDialog" persistent width="600">
      <v-card v-if="externalApiVm">
        <v-card-title>Ustawienia zewnetrznego API</v-card-title>
        <v-card-text>
          <v-switch v-model="externalApiVm.enabled" label="Włącz zewnętrzne API"></v-switch>
          <span>Klucz wdrożenia: {{ externalApiVm.apiKey }}</span>
          <br/><v-btn color="primary" @click="generateNewApiKey()">Generuj nowy klucz</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="saveExternalApiSettings()">Zapisz</v-btn>
          <v-btn color="secondary" @click="externalApiDialog = false">Zamknij</v-btn>
        </v-card-actions> </v-card>
    </v-dialog>
    <message-modal ref="messageModal"></message-modal>
    <company-ip-white-list ref="ipwhitelist"></company-ip-white-list>
  </div>
</template>

<script>import { v4 as uuidv4 } from 'uuid';
import { showError, showInfo } from "@/helpers";
import MessageModal from "@/components/MessageModal";
import CompanyIpWhiteList from "@/pages/CompanyIpWhiteList.vue";
export default {
  components: {
    MessageModal,
    CompanyIpWhiteList,
  },
  data() {
    return {
      emailSenderDialog: false,
      confirmNewReadonlyGuidDialog: false,
      confirmNewGuidDialog: false,
      securitySettingsDialog: false,
      newGuidVm: {
        id: 0,
        name: "",
        shortName: "",
        email: "",
      },
      newCompanyDialog: false,
      newCompanyVm: {
        name: "",
        shortName: "",
        email: "",
      },
      confirmRemoveDialog: false,
      removeCompany: {
        id: 0,
        name: "",
        email: "",
      },
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Nazwa",
          value: "name",
          width: "10%",
        },
        {
          text: "Skrócona nazwa",
          value: "shortName",
          width: "10%",
        },
        {
          text: "Adres email",
          value: "email",
          width: "15%",
        },
        {
          text: "Domena",
          value: "domain",
        },
        {
          text: "Data utworzenia",
          value: "createDateTime",
        },
        {
          text: "Ważny od",
          value: "validFromDateTime",
        },
        {
          text: "Ważny do",
          value: "validToDateTime",
        },
        {
          text: "klucz dostępu",
          value: "accessToken",
          width: "10%",
        },
        {
          text: "klucz tylko do odczytu",
          value: "readonlyAccessToken",
        },
        {
          text: "Opcje",
          value: "actions",
        },
      ],
      companies: [],
      isInit: false,
      addCompanyMessage: "",
      copyConfigsDialog: false,
      copyVm: { fromCompany: 0, toCompany: 0 },
      emailSettings: null,
      securitySettings: null,
      smsApiPointsDialog: false,
      smsApiPointsVm: null,
      externalApiDialog: false,
      externalApiVm: null,
    };
  },
  methods: {
    saveEdit(item) {
      var vm = this;
      vm.$http
        .post("/Company/UpdateCompany", item)
        .then(() => { })
        .catch((error) => {
          if (
            error.response.data &&
            error.response.data.toLowerCase() == "same company exist"
          ) {
            showError("Istnieje już podobne wdrożenie, wprowadź inne dane");
          }
        });
    },
    async getSmsApiPoints(item) {
      const { data } = await this.$http.get(
        "/Company/GetCompanySmsApiPoints?companyId=" + item.id
      );
      this.smsApiPointsDialog = true;
      this.smsApiPointsVm = data;
    },
    async saveEmailSender() {
      await this.$http.post("/Company/UpdateEmailSettings", this.emailSettings);
      this.emailSenderDialog = false;
      showInfo("Zapisano zmiany");
    },
    async editEmailSender(item) {
      this.emailSettings = null;
      const { data } = await this.$http.get(
        "/Company/GetEmailSettings?companyId=" + item.id
      );
      this.emailSettings = data;
      this.emailSenderDialog = true;
    },
    async saveSecurity() {
      await this.$http.post(
        "/Company/UpdateSecuritySettings",
        this.securitySettings
      );
      this.securitySettingsDialog = false;
      showInfo("Zapisano zmiany");
    },
    async editSecurity(item) {
      this.securitySettings = null;
      const { data } = await this.$http.get(
        "/Company/GetSecuritySettings?companyId=" + item.id
      );
      this.securitySettings = data;
      this.securitySettingsDialog = true;
    },
    downloadCompanies() {
      var vm = this;
      vm.$http.get("/Company/GetCompanies").then((response) => {
        response.data.forEach((element) => {
          element.showToken = false;
          element.showReadonlyToken = false;
        });
        vm.companies = response.data;
        vm.isInit = true;
      });
    },
    newCompany() {
      var vm = this;
      vm.addCompanyMessage = "";
      vm.$http
        .post("/Company/AddCompany", vm.newCompanyVm)
        .then((response) => {
          vm.newCompanyDialog = false;
          var newCompany = response.data;
          vm.companies.push(newCompany);
          vm.$refs.messageModal.showMessage(
            "Utworzono nowe wdrożenie",
            `Utworzono wdrożenie: ${newCompany.name}<br/>Nadano klucz: ${newCompany.accessToken}`
          );
        })
        .catch((error) => {
          if (
            error.response.data &&
            error.response.data.toLowerCase() == "same company exist"
          ) {
            vm.addCompanyMessage =
              "Istnieje już podobne wdrożenie, wprowadź inne dane";
          }
        });
    },
    openRemoveCompanyDialog(company) {
      var vm = this;
      vm.removeCompany = {
        id: company.id,
        name: company.name,
        shortName: company.shorName,
        email: company.email,
      };
      vm.confirmRemoveDialog = true;
    },
    removeNotConfirm() {
      var vm = this;
      vm.removeCompany = {
        id: 0,
        name: "",
        shortName: "",
        email: "",
      };
      vm.confirmRemoveDialog = false;
    },
    confirmRemoveCompany() {
      var vm = this;
      var id = vm.removeCompany.id;
      vm.$http.delete("/Company/RemoveCompany?id=" + id).then(() => {
        var comp = vm.companies.find((el) => el.id == id);
        var index = vm.companies.indexOf(comp);
        vm.companies.splice(index, 1);
        vm.confirmRemoveDialog = false;
      });
    },
    openNewGuidDialog(company) {
      var vm = this;
      vm.newGuidVm = {
        id: company.id,
        name: company.name,
        shortName: company.shortName,
        email: company.email,
      };
      vm.confirmNewGuidDialog = true;
    },
    openNewReadonlyGuidDialog(company) {
      var vm = this;
      vm.newGuidVm = {
        id: company.id,
        name: company.name,
        shortName: company.shortName,
        email: company.email,
      };
      vm.confirmNewReadonlyGuidDialog = true;
    },
    newGuidNotConfirm() {
      var vm = this;
      vm.newGuidVm = {
        id: 0,
        name: "",
        shortName: "",
        email: "",
      };
      vm.confirmNewGuidDialog = false;
      vm.confirmNewReadonlyGuidDialog = false;
    },
    generateNewReadonlyGuid() {
      var vm = this;
      var companyId = vm.newGuidVm.id;
      vm.$http
        .get(`/Company/GenerateNewReadonlyGuid?id=${companyId}`)
        .then((response) => {
          var company = vm.companies.find((element) => element.id == companyId);
          if (company) {
            company.readonlyAccessToken = response.data.readonlyAccessToken;
            vm.confirmNewReadonlyGuidDialog = false;
          }
        })
        .catch(() => {
          vm.confirmNewReadonlyGuidDialog = false;
        });
    },
    generateNewGuid() {
      var vm = this;
      var companyId = vm.newGuidVm.id;
      vm.$http
        .get(`/Company/GenerateNewGuid?id=${companyId}`)
        .then((response) => {
          var company = vm.companies.find((element) => element.id == companyId);
          if (company) {
            company.accessToken = response.data.accessToken;
            vm.confirmNewGuidDialog = false;
          }
        })
        .catch(() => {
          vm.confirmNewGuidDialog = false;
        });
    },
    routeToConfiguration(company) {
      this.$router.push("Companies/Configuration/" + company.id);
    },
    routeToFront(company) {
      let baseUrl = document.baseFrontUrl;
      if (!baseUrl.endsWith("/")) {
        baseUrl += "/";
      }
      document.location.href = baseUrl + company.shortName;
    },
    openCopyConfigsDialog(company) {
      this.copyVm.toCompany = company.id;
      this.copyConfigsDialog = true;
      this.copyVm.fromCompany = null;
    },
    async copyConfigConfirm() {
      const { data } = await this.$http.post("Company/CopyConfig", this.copyVm);
      if (data) {
        this.copyConfigsDialog = false;
        showInfo("Skopiowano ustawienia");
      }
    },
    async editExternalApi(item) {
      this.externalApiVm = null;
      this.externalApiDialog = true;
      const { data } = await this.$http
        .get("/Company/GetExternalApiSettings?companyId=" + item.id);

      this.externalApiVm = data;
    },
    async saveExternalApiSettings() {
      await this.$http.post(
        "/Company/UpdateExternalApiSettings",
        this.externalApiVm
      );
      this.externalApiDialog = false;
      showInfo("Zapisano zmiany");
    },
    generateNewApiKey(){
      this.externalApiVm.apiKey = uuidv4();

    }
  },
  mounted() {
    var vm = this;
    vm.downloadCompanies();
  },
};
</script>
